import { store } from '@/store';
import { 
  getEffectiveTimezone as getEffectiveTimezoneCore,
  formatInUserTimezone as formatInUserTimezoneCore,
  getTimezoneAbbreviation as getTimezoneAbbreviationCore,
  toUserTimezone as toUserTimezoneCore,
  invalidateTimezoneCache
} from './timezoneUtils';

/**
 * Get the effective timezone for the current user (store-connected version)
 */
export function getEffectiveTimezone(): string {
  const state = store.getState();
  return getEffectiveTimezoneCore(state.auth.user, state.organization.settings);
}

/**
 * Format a date/time string in the user's effective timezone (store-connected version)
 */
export function formatInUserTimezone(
  dateTime: string | null,
  format: string = 'h:mm A',
  showTimezone: boolean = true
): string {
  const state = store.getState();
  return formatInUserTimezoneCore(dateTime, format, showTimezone, state.auth.user, state.organization.settings);
}

/**
 * Get timezone abbreviation for the effective timezone (store-connected version)
 */
export function getTimezoneAbbreviation(date?: string | Date): string {
  const state = store.getState();
  return getTimezoneAbbreviationCore(state.auth.user, state.organization.settings, date);
}

/**
 * Convert a date/time to the user's effective timezone (store-connected version)
 */
export function toUserTimezone(dateTime: string) {
  const state = store.getState();
  return toUserTimezoneCore(dateTime, state.auth.user, state.organization.settings);
}

// Re-export the cache invalidation function
export { invalidateTimezoneCache };
